import React, { useCallback, useState } from 'react';

import { Tooltip, Rating, CopyText } from '../../../../UiKit';
import { ChevronRight } from 'sushiweb/Icons';
import { ValetTags } from '../ValetTags';
import SpinnerCircular from 'sushiweb/Spinner/SpinnerCircular';
import { WFHCall } from '../../../commons';
import { viewText } from '../../../../images/images';
import { valetModel } from '../../../../api';
import toast from 'react-hot-toast';
import {
  VALET_EVENTS,
  sendValetApiEvents,
} from '../../../../helpers/analytics/valet.analytics';

import {
  headPhone,
  nonLogsRider,
  noAmbulance,
  smallRider,
  riderScooter,
} from '../../../../images/images';
import { OrderOtp } from '../OrderOtp';
import { useQueryCall } from '../../../../api/react-client';
import { lifelineEndPoints } from '../../../../api/end-points';
import { ValetCallClickEvent } from '../../../../analytics/call-logging/events';

const NoValetAssigned = ({ orderStatus, assignmentsHistoryComp }) => {
  return (
    <div className='noValetAssignedContainer'>
      <div className='noValetAssignedImgContainer'>
        <div className='noValetAssignedImg'>
          <img src={smallRider} alt='' />
        </div>
        {assignmentsHistoryComp}
      </div>

      {orderStatus === 'DELIVERED' ? (
        <>
          <p className='dark large'>Valet details unavailable</p>
          <p className='lighter'>Order was delivered</p>
        </>
      ) : (
        <>
          <p className='dark large'>No Valet assigned</p>
          {orderStatus === 'CANCELLED' ? (
            <p className='lighter'>
              Order was cancelled before Valet assignment
            </p>
          ) : null}
        </>
      )}
    </div>
  );
};

function unmaskNumber(orderID, setNumber, setisMask) {
  const queryParams = {
    order_id: orderID,
  };

  valetModel
    .getValetNumber(queryParams)
    .then((response) => {
      if (!response || response?.isError === true) {
        return toast.error(
          response.message || 'Something went wrong. Please try again later!',
        );
      }

      sendValetApiEvents(VALET_EVENTS.GET_VALET_NUMBER_SUCCESS, orderID);
      setisMask(false);
      setNumber(response.phone_number);
    })
    .catch((err) => {
      toast.error(
        err.message || 'Something went wrong. Please try again later!',
      );

      sendValetApiEvents(VALET_EVENTS.GET_VALET_NUMBER_FAILURE, orderID);
    });
}

const ValetPhoneNumbers = ({
  phoneNumbers,
  isWFH,
  orderId,
  userId,
  calledTo = 'Rider',
  orderBasicInfo = {},
  valetName = '',
}) => {
  const valetNumbers = phoneNumbers.slice(0, 2);
  const [isMask, setisMask] = useState(true);

  if (!phoneNumbers || (phoneNumbers && !phoneNumbers.length)) return null;
  return (
    <div className='valetNumbersContainer tw-h-2/5'>
      {valetNumbers.map((number, index) => {
        const [phone, setPhone] = useState(number);
        return (
          <div
            key={index}
            className='tw-flex tw-flex-row tw-justify-between phoneWrapper'
          >
            <div>
              <span className='icon iconMarginR'>
                <img src={headPhone} alt='' />
              </span>
              {isMask ? (
                <div>
                  <CopyText
                    dontShowCopyIcon={true}
                    title={phone}
                    orderId={orderId}
                    userId={userId}
                    masking={false}
                    maskingCount={4}
                    calledTo={calledTo}
                  />
                </div>
              ) : (
                <div>
                  <CopyText
                    title={phone}
                    orderId={orderId}
                    userId={userId}
                    masking={false}
                    maskingCount={4}
                    calledTo={calledTo}
                  />
                </div>
              )}
            </div>
            <div>
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
              <span
                className='pointer icon tw-mr-2'
                onClick={() => unmaskNumber(orderId, setPhone, setisMask)}
              >
                <img src={viewText} alt='' />
              </span>
              {isWFH ? (
                <WFHCall
                  orderId={orderId}
                  userId={userId}
                  title={number}
                  calledTo={calledTo}
                  sendJumboEvent={true}
                  jumboEventFunc={ValetCallClickEvent}
                  JumboEventProperties={{
                    valet_name: valetName,
                    valet_number: number,
                    is_new_ui: false,
                  }}
                  cartId={orderBasicInfo?.order?.cart_id}
                />
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const ValetInfo = ({
  valetTitle = '',
  orderId,
  valet = {},
  valetId,
  userId,
  isWFH,
  getAssignments = () => {},
  noData,
  orderBasicInfo,
}) => {
  const assignmentsHistoryComp = (
    <div>
      <AssignmentHistory orderId={orderId} getAssignments={getAssignments} />
    </div>
  );

  if (noData) {
    return (
      <div className='valetNoDataContainer'>
        <div className='valetTitle lighter'>{valetTitle}</div>
        <div className='valetNoDataSubContainer'>
          <div className='noValetAssignedImg'>
            <img
              src={valetTitle == 'Medical Partner' ? noAmbulance : nonLogsRider}
              alt=''
            />
          </div>
          {assignmentsHistoryComp}
        </div>
      </div>
    );
  }

  const ambulanceRoles = [
    'Paramedic',
    'Ambulance Pilot',
    'General Duty Assistant',
  ];
  const valetName = valet?.name ? valet.name : '';
  const valetText = valet?.tags?.length > 0 ? valet.tags[0].text : '';
  const calledTo = ambulanceRoles.includes(valetText) ? valetText : 'Rider';

  if (!valetName) {
    return (
      <NoValetAssigned
        orderStatus={valet?.order_status}
        assignmentsHistoryComp={assignmentsHistoryComp}
      />
    );
  }

  const valetPhoneNumbers = valet?.phone_number
    ? valet?.phone_number.split(',')
    : '';

  const num_of_buddy_riders = valet?.buddy_riders?.length;
  // const num_of_buddy_riders = 3;
  return (
    <div className='valetInfoContainer tw-h-full tw-w-full' data-dd-privacy='mask'>
      {num_of_buddy_riders ? (
        <div className='buddyRidersLabel'>
          <p>+{num_of_buddy_riders} Buddy Rider(s)</p>
          <AssignmentHistory
            orderId={orderId}
            getAssignments={getAssignments}
            iconColor='#0a757c'
            iconSize={16}
          />
        </div>
      ) : null}
      <div className='valetInfoGridContainer'>
        <div className='riderIconGridItem'>
          <div className='riderIconContainer'>
            <img className='riderIcon' src={riderScooter} alt='bike' />
          </div>
        </div>
        <div className='valetInfoAndRatingGridItem'>
          <div className='valetInfoAndRating'>
            <div className='valetTitle lighter'>
              {valetTitle}
              {valetId && (
                <CopyText
                  title={`#${valetId}`}
                  customClass='valetTitle lighter tw-ml-1'
                />
              )}
            </div>
            <div className='valetNameRating'>
              <p className='dark large wrap'>{valetName}</p>
              {valet?.rating && (
                <div className='valetRating'>
                  <Rating
                    title={valet?.rating?.text}
                    bgColor={valet?.rating?.bg_color}
                  />
                </div>
              )}
            </div>
          </div>
          {assignmentsHistoryComp}
        </div>
        <div className='emptyGridItem'></div>
        {valet?.tags?.length ? <ValetTags valet={valet} /> : null}
      </div>

      <div className='valetOtherInfoContainer'>
        {valetPhoneNumbers.length > 0 && (
          <ValetPhoneNumbers
            phoneNumbers={valetPhoneNumbers}
            isWFH={isWFH}
            orderId={orderId}
            userId={userId}
            calledTo={calledTo}
            orderBasicInfo={orderBasicInfo}
            valetName={valetName}
          />
        )}
        {orderBasicInfo?.order?.is_otp_enabled && (
          <div className='tw-my-2'>
            <OrderOtp orderId={orderId} />
          </div>
        )}
      </div>
    </div>
  );
};

function AssignmentHistory({
  orderId,
  getAssignments,
  iconColor,
  iconSize = 20,
}) {
  const queryKeys = [
    'lifeline_apis',
    'logistics',
    'get_assignment_history',
    orderId,
  ];
  const getAssignmentsHistoryEndPoint = `${lifelineEndPoints.GET_ASSIGNMENT_HISTORY}?order_id=${orderId}`;
  const { isLoading, data, isError } = useQueryCall(
    {},
    getAssignmentsHistoryEndPoint,
    queryKeys,
  );

  let classNames = 'icon assignmentHistoryIcon';
  let icon = <SpinnerCircular size='small' color='#696969' />;
  if (!isLoading && !isError) {
    classNames = classNames + ' pointer';
    icon = (
      <ChevronRight
        size={iconSize}
        color={iconColor ? iconColor : data?.btn_color ?? '#696969'}
      />
    );
  }

  const onIconClick = useCallback(() => {
    if (isLoading || isError) {
      return null;
    }
    getAssignments(data);
  }, [data, getAssignments, isError, isLoading]);

  return (
    <Tooltip
      title={
        <span
          className={classNames}
          onClick={onIconClick}
          role='button'
          tabIndex={0}
        >
          {icon}
        </span>
      }
      position={'bottom'}
      border={false}
      label={data?.label || 'Delivery Partner Assignments History'}
    />
  );
}
